<template>
  <GridContainer>
    <GridItem v-for="(mapObj, index) in maps" :key="index" :width="width" :height="height">
      <text :x="x" :y="y">{{ mapObj.properties.name }}</text>
      <BackgroundIsland :d="path(mapObj)" :id="mapObj.properties.name" />
      <path :d="path(mapObj)" :id="mapObj.properties.name" fill="#00A651" stroke="black" />
    </GridItem>
  </GridContainer>
</template>

<script>
import pacificJson from '@shared/utils/topojson/regions/PI/subdivisions.topo.json';
import { feature } from 'topojson-client';
import { geoMercator, geoPath } from 'd3-geo';
import {GridContainer, BackgroundIsland, GridItem} from '../pacificGrid/pacificGrid.styles'

export default {
  name: 'PacificGrid',
  components: {
    GridContainer,
    BackgroundIsland,
    GridItem
  },
  data() {
    return {
      maps: feature(pacificJson, pacificJson.objects.subdivisions).features,
      x: 5,
      y: 20,
      width: 225,
      height: 225,
    };
  },
  methods: {
    path(feature) {
      const projection = geoMercator()
        .translate([this.width / 2, this.height / 2])
        .scale(feature.properties.scale)
        .center(feature.properties.center);
      const path = geoPath().projection(projection);
      return path(feature);
    },
  },
};
</script>